import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { AddTeamMemberApi } from "./TeamMemberAction";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";


const AddTeamMember = (props) => {
    const [name, setName] = useState("");
    const [fatherName, setFatherName] = useState("");
    const [residentID, setResidentID] = useState("");
    const [department, setDepartment] = useState("");
    const [designation, setDesignation] = useState("");
    const [qualification, setQualification] = useState("");
    const [employeeType, setEmployeeType] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

    function SaveTeamMember() {
        props.AddTeamMemberApi({
            name: name,
            fatherName: fatherName,
            residentID: residentID,
            department: department,
            designation: designation,
            qualification: qualification,
            employeeType: employeeType,
        },
            handleVisible,
            handleDangerVisible
        );
        setName("");
        setFatherName("");
        setResidentID("");
        setDepartment("");
        setDesignation("");
        setQualification("");
        setEmployeeType("");
    }
    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };

    const employeeTypes = [
        { value: "Partner", label: "Partner" },
        { value: "Manager", label: "Manager" },
        { value: "Supervisor", label: "Supervisor" },
        { value: "Junior", label: "Junior" },
    ]
    const handleChangeEmployeeType = (selectedOption) => {
        setEmployeeType(selectedOption.label);
    };

    useEffect(() => {
        props.setHeading("Add Team Member");
    }, []);

    return (
        <>
            {props.isAddingTeamMember ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Name *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Name"
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Father Name </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Father Name"
                                        onChange={(e) => setFatherName(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Resident ID </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Resident ID"
                                        onChange={(e) => setResidentID(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Department </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Department"
                                        onChange={(e) => setDepartment(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Designation </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Designation"
                                        onChange={(e) => setDesignation(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Qualification </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Qualification"
                                        onChange={(e) => setQualification(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Employee Type</b></Form.Label>
                                    <Select
                                        placeholder="Select Product"
                                        onChange={handleChangeEmployeeType}
                                        options={employeeTypes}
                                    // isMulti={true}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(name) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveTeamMember}> SAVE </Button>
                            )}
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddTeamMemberApi: (data, handleVisible, handleDangerVisible) => dispatch(AddTeamMemberApi(data, handleVisible, handleDangerVisible)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingTeamMember: state.TeamMemberReducer.isAddingTeamMember,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTeamMember);
